import {Component, OnDestroy, OnInit} from '@angular/core';
import {Report} from '../../model/report';
import {Dictionary} from '../../model/dictionary';
import {UserReportsService} from './user-reports.service';
import {forkJoin} from 'rxjs/observable/forkJoin';
import {NotificationType} from '../notifier/notification-type.enum';
import {NotifierService} from '../notifier/notifier.service';
import {CommonService} from '../../common/common.service';
import {TopMenuService} from '../top-menu/top-menu.service';
import {UserReportsPagerService} from './user-reports-pager.service';
import {saveAs} from 'file-saver';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {User} from '../../model/user';
import {ActivatedRoute, Router} from "@angular/router";
import {HeaderService} from "../header/header.service";
import {UserSavedReportsService} from '../user-saved-reports/user-saved-reports.service';
import {MainMenuService} from '../header/main-menu/main-menu.service';
import {LoaderService} from "../spinner/loader.service";
import {BreadcumbsService} from "../breadcumbs/breadcumbs.service";
import {PredefinedDateEnum} from "./predefined-date-enum.enum";
import {NgbCalendarGregorian} from "@ng-bootstrap/ng-bootstrap/datepicker/ngb-calendar";
import {Pager} from "../../model/pager";
import {AbstractReport} from "../../common/abstract-report";

@Component({
  selector: 'pbc-user-reports',
  templateUrl: './user-reports.component.html',
  styleUrls: ['./user-reports.component.css']
})
export class UserReportsComponent extends AbstractReport implements OnInit {
  private reports: Array<Report> = [];
  private newReportsToBeUntouched: Array<number> = [];

  private readonly homeMenuContent: Dictionary = {
    id: null,
    value: "Raporty",
    value_1: "",
    enabled: true,
    dictId: 999
  };

  private readonly newReportsContent: Dictionary = {
    id: null,
    value: "Nowe raporty",
    value_1: "",
    enabled: true,
    dictId: 9999
  };

  //czy jesteśmy w trakcie wyświetlania samouczka
  selfTutorInProgress = false;

  //czy odswieżyć raporty po zamknięciu samouczka
  refreshOnCloseSelfTutor = false;

  //Akcje na formularzu
  private reportShowMoreList: Array<number> = [];
  showDownloadReport: boolean = false;
  showDownloadDemo: boolean = false;
  showContactForm: boolean = false;
  private reportToOperateOn: Report;

  //Filtry
  private contentTypeForFilter: Array<Dictionary> = [];
  private fileFormatsForFilter: Array<string> = [];
  private thematicsFrequenciesForFilter: Array<Dictionary> = [];
  private thematicsAreaForFilter: Array<Dictionary> = [];
  private thematicsProductsForFilter: Array<Dictionary> = [];
  private thematicsInstitutionForFilter: Array<Dictionary> = [];
  private thematicsClientGroupsForFilter: Array<Dictionary> = [];
  predefinedDate: PredefinedDateEnum;
  predefinedDateEnum = PredefinedDateEnum;
  private ngbCalendar = new NgbCalendarGregorian();

  showFilterPopup: boolean = false;
  private numberOfFilterCriteria: number = 0;
  private filteredReportsCounter: number = 0;

  private pager: Pager = new Pager(0, 0, 0, 0, 0, 0, 0, 0, []);
  private pagedReports: Array<Report> = [];
  private static pageSize: number = 10;
  private currentPage: number = 1;

  private loggedUserId: number = null;
  private loggedUser: User;
  newReports = false;

  showReportShare: boolean = false;
  shareReportForm: FormGroup;
  private contactForm: FormGroup;
  private contactFormMessage: string = '';

  showStartTourComponent = false;

  public showAccessNotGrantedMessage = true;

  private shareReportMessage: string = "";

  // public searchItems: Array<SearchItem> = [];

  constructor(
    private userReportsService: UserReportsService,
    private notifierService: NotifierService,
    private commonService: CommonService,
    private topMenuService: TopMenuService,
    private headerService: HeaderService,
    private userReportsPagerService: UserReportsPagerService,
    private routerService: Router,
    private userSavedReportsService: UserSavedReportsService,
    private mainMenuService: MainMenuService,
    private activatedRoute: ActivatedRoute,
    public loaderService: LoaderService,
    public breadCrumbService: BreadcumbsService,
  ) {
    super();
  }

  predefinedDateOnClick(predefinedDate: PredefinedDateEnum) {
    this.dateToFilter = this.ngbCalendar.getToday();

    if (predefinedDate == PredefinedDateEnum.lastWeek)
      this.dateFromFilter = this.ngbCalendar.getPrev(this.dateToFilter, "d", 7);
    if (predefinedDate == PredefinedDateEnum.lastMonth)
      this.dateFromFilter = this.ngbCalendar.getPrev(this.dateToFilter, "m", 1);
    if (predefinedDate == PredefinedDateEnum.lastYear)
      this.dateFromFilter = this.ngbCalendar.getPrev(this.dateToFilter, "m", 12);

    if (this.dateFromFilter) this.numberOfFilterCriteria++;
    if (this.dateToFilter) this.numberOfFilterCriteria++;

    this.getReports(false);
  }

  updateUserReportsCount() {
    let filterParams = {};
    filterParams['id'] = this.loggedUserId;
    this.userSavedReportsService.getReportsCount(filterParams).subscribe(
      result => {
        this.topMenuService.userReportsCount.emit(result.record);
      })
  }

  ngOnInit() {
    let authData = JSON.parse(localStorage.getItem('auth_data'));
    this.loggedUserId = authData.user.id;
    this.loggedUser = authData.user;
    this.headerService.hideLoginRegisterButtons();
    this.headerService.isHomepage(false);

    this.userReportsService.refreshOnCloseSelfTutor.subscribe(value => {
      this.refreshOnCloseSelfTutor = value;
    });

    this.mainMenuService.markReportAsShown.subscribe(
      reports => {
        this.newReportsToBeUntouched = reports.map(report=>report.id);
      }
    )

    this.userReportsService.selfTutorInProgress.subscribe(value => {
      this.selfTutorInProgress = value;
      if (this.refreshOnCloseSelfTutor)
        this.getReports(true);
    });

    this.activatedRoute.params.subscribe(queryParams => {
      const dictId = queryParams['dictId'];
      let selfTutorInProgress = false;
      if (queryParams['selftutor'] && queryParams['selftutor'] == "true")
        selfTutorInProgress = true;

      this.newReports = queryParams['newReports'];

      if (queryParams['searchcriteria'])
        this.searchItems = JSON.parse(queryParams['searchcriteria']);

      this.reportToOperateOn = undefined;
      this.showDownloadReport = false;

      this.currentPage = 1;
      this.pagedReports = [];

      this.clearFilters();
      if (dictId > 0) {
        this.userReportsService.getContentTypeById(dictId).subscribe(
          data => {
            this.contentTypeSelected = data;
            if (!selfTutorInProgress && !this.searchItems.length) {
              this.commonService.prefilterUserReports(this.buildFilterParams(false)).subscribe(
                result => {
                  if (result.status != 1) {
                    console.log(result);
                    this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, 'Błąd w trakcie pobierania listy raportów');
                  } else {
                    this.countedReports = result.record;
                    this.filteredReportsCounter = this.countedReports;
                    this.pager = this.userReportsPagerService.getPager(result.record, 1, UserReportsComponent.pageSize);
                    this.getReports(true, this.currentPage, UserReportsComponent.pageSize);
                  }
                },
                error => {
                  console.log(error);
                  this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, 'Błąd w trakcie pobierania listy raportów');
                }
              )
            }
          },
          error => {
            console.log(error);
            this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, 'Błąd w trakcie pobierania danych');
          }
        );
        this.commonService.hasAccessToContentType(dictId).subscribe(
          data => {
            if (data.status == 1) {
              if (Boolean(data.message) === true)
                this.showAccessNotGrantedMessage = false;
              else
                this.showAccessNotGrantedMessage = true;
            }
          },
          error => {
            console.log(error);
          }
        )
      } else {
        this.showAccessNotGrantedMessage = false;

        if (this.newReports) {
          this.contentTypeSelected = this.newReportsContent;
          setTimeout(() => this.breadCrumbService.setSubfolder.emit('Nowe raporty'), 100);
        }
          else {
          this.contentTypeSelected = this.homeMenuContent;
          setTimeout(() => this.breadCrumbService.setSubfolder.emit(this.homeMenuContent.value_1), 100);
        }

        if (!selfTutorInProgress && !this.searchItems.length) {
          let filterParams = this.buildFilterParams(false)

          if (this.newReports) {
            this.setFilterParamsForNewReports(filterParams);
          }

          this.commonService.prefilterUserReports(filterParams).subscribe(
            result => {
              if (result.status != 1) {
                console.log(result);
                this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, 'Błąd w trakcie pobierania listy raportów');
              } else {
                this.countedReports = result.record;
                this.filteredReportsCounter = this.countedReports;
                this.pager = this.userReportsPagerService.getPager(result.record, 1, UserReportsComponent.pageSize);
                this.getReports(true, this.currentPage, UserReportsComponent.pageSize);
              }
            },
            error => {
              console.log(error);
              this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, 'Błąd w trakcie pobierania listy raportów');
            }
          )
        }
      }
    });

    this.getDictionaries();

    const userName = authData.user.firstName + ' ' + authData.user.lastName;
    this.shareReportForm = new FormGroup({
      'email': new FormControl('', [Validators.email, Validators.required]),
      'message': new FormControl(this.shareReportMessage),
      'sendCopy': new FormControl('')
    });

    this.contactForm = new FormGroup({
      'email': new FormControl({value: this.loggedUser.email, disabled: true},
        [Validators.email, Validators.required]),
      'firstLastName': new FormControl(
        {value: this.loggedUser.firstName.concat(' ', this.loggedUser.lastName), disabled: true}, Validators.required),
      'phoneNumber': new FormControl({value: this.loggedUser.workPhone, disabled: true}),
      'message': new FormControl(this.contactFormMessage, Validators.required),
      'sendCopy': new FormControl(false),
      'agreement': new FormControl(false, Validators.requiredTrue)
    });
  }

  private setFilterParamsForNewReports(filterParams : Object) {
    filterParams['published'] = true;
    filterParams['sortString'] = 'shownToUser'
    let dateFrom = this.ngbCalendar.getToday();

    //Szukamy raportów opublikowanych miesiąc wstecz
    dateFrom = this.ngbCalendar.getPrev(dateFrom, "m", 1);
    filterParams['dateFrom'] = new Date(dateFrom.year, dateFrom.month -1, dateFrom.day);
  }

  private orderByClick(orderByField: string) {
    if (orderByField === this.orderByField)
      this.orderAsc = !this.orderAsc;
    else {
      this.orderAsc = true;
      this.orderByField = orderByField;
    }
    this.getReports(true, this.currentPage, UserReportsComponent.pageSize, false);
  }

  private getReports(returnResult: boolean, pageNumber: number = 0, pageSize: number = 10, fromSearchBox: boolean = false) {
    let filterParams = this.buildFilterParams(fromSearchBox);

    if (this.newReports) {
      this.setFilterParamsForNewReports(filterParams);
    }

    this.updateUserReportsCount();

    if (returnResult) { //jesli mamy zwrócić wynik, to pobieramy raporty
      filterParams['pageNumber'] = pageNumber;
      filterParams['pageSize'] = pageSize;

      console.log('getReports filterParams:', filterParams);

      this.commonService.getUserReports(filterParams).subscribe(
        data => {
          if (data.status != 1) {
            this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, 'Błąd w trakcie pobierania listy raportów');
          } else {

            if (data.record.length > 0 && fromSearchBox)
              this.topMenuService.reloadSuggestions.emit(true)

            this.reports = data.record;

            //Raporty z poprzedniej strony zapisuje do bazy jako wyswietlone
            let reportsNotShownToUser: Array<number> = [];
            this.reports.forEach(report => {
              if (!report.shownToUser)
                reportsNotShownToUser.push(report.id);
            });

            if (reportsNotShownToUser.length > 0)
              this.userReportsService.markAsShownOnUserList(reportsNotShownToUser, this.loggedUserId).subscribe(
                data => {
                  if (data.status !== 1) {
                    this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, 'Wystąpił błąd: Nie można zapisać informacji');
                  }
                },
                err => {
                  console.log('err:', err);
                  this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, 'Wystąpił błąd: Nie można zapisać informacji');
                }
              );

            //Jesli otrzymano listę raportów do oznaczenia jako nieprzeczytane to na potrzeby widoku oznaczam go jako nieprzeczytany.
            //Dodatkowo - raporty raz oznaczone jako nieprzeczytane nie mogą po raz kolejny pojawić się jako nieprzeczytane, dlatego
            //rejestr newReportsToBeUntouched jest czyszczony z tych które już były oznaczone.
            if (this.newReportsToBeUntouched.length > 0)
              for (let i = 0; i < this.reports.length; i++) {
                let position = this.newReportsToBeUntouched.indexOf(this.reports[i].id);
                if (position != -1) {
                  this.reports[i].shownToUser = false;
                  this.newReportsToBeUntouched.splice(position,1);
                  i--;
                }
              }

            this.showStartTourComponent = !this.loggedUser.invitationShownToUser;
            //Zapisuje w storage, ze widziano już popup powitalny
            let authData = JSON.parse(localStorage.getItem('auth_data'));
            authData.user.invitationShownToUser = true;
            localStorage.setItem('auth_data', JSON.stringify(authData));
          }
        },
        error => {
          console.log(error);
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, 'Błąd w trakcie pobierania listy raportów');
        }
      )
    }

    if (!returnResult)
      this.commonService.prefilterUserReports(filterParams).subscribe(
        data => {
          if (data.status != 1)
            this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, 'Bład w trakcie pobierania danych');
          else
            this.filteredReportsCounter = data.record;
        },
        error => {
          console.log(error);
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, 'Błąd w trakcie pobierania danych');
        }
      )
  }

  private getDictionaries() {
    forkJoin(
      this.commonService.getAreaDictionary(),
      this.commonService.getClientGroupsDictionary(),
      this.commonService.getInstitutionDictionary(),
      this.commonService.getProductsDictionary(),
      this.commonService.getFrequencyDictionary(),
      this.commonService.getContentTypeDictionary(),
      this.userReportsService.getFileFormats()
    ).subscribe(([areas, clientGroups, institutions, products, frequencies, contentTypes, fileFormatsResult]) => {
        this.thematicsAreaForFilter = areas;
        this.thematicsClientGroupsForFilter = clientGroups;
        this.thematicsInstitutionForFilter = institutions;
        this.thematicsProductsForFilter = products;
        this.thematicsFrequenciesForFilter = frequencies;
        this.contentTypeForFilter = contentTypes;
        this.fileFormatsForFilter = fileFormatsResult;
      },
      (error) => {
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Wystąpił błąd! Nie pobrano słowników");
        console.log("Wystąpił błąd! Nie pobrano słowników:", JSON.stringify(error));
      });
  }

  filterWithDateTo(): void {
    this.predefinedDate = undefined;
    if (this.dateToFilter)
      this.numberOfFilterCriteria++;
    // this.getReports(false);
    this.prefilterDataForFilter();
  }

  filterWithDateFrom(): void {
    this.predefinedDate = undefined;
    if (this.dateFromFilter)
      this.numberOfFilterCriteria++;

    this.prefilterDataForFilter();
  }

  modifyHasRightElementList(hasRights: boolean, showResults?: boolean) {
    let position = this.hasRightsForFilterSelected.indexOf(hasRights);
    if (position == -1)
      this.hasRightsForFilterSelected.push(hasRights);
    else
      this.hasRightsForFilterSelected.splice(position, 1);

    this.numberOfFilterCriteria = this.fileFormatsForFilterSelected.length
      + this.thematicsAreaForFilterSelected.length
      + this.thematicsClientGroupsForFilterSelected.length
      + this.thematicsFrequenciesForFilterSelected.length
      + this.thematicsInstitutionForFilterSelected.length
      + this.thematicsInstitutionForFilterSelected.length
      + this.contentTypeForFilterSelected.length
      + this.thematicsProductsForFilterSelected.length
      + this.hasRightsForFilterSelected.length;

    if (showResults)
      this.setPageWithProperData(this.currentPage);
    else
      this.prefilterDataForFilter();
  }

  prefilterDataForFilter() {
    this.commonService.prefilterUserReports(this.buildFilterParams()).subscribe(
      result => {
        if (result.status != 1) {
          console.error(result);
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, 'Błąd w trakcie pobierania listy raportów');
        } else {
          this.countedReports = result.record;
          this.filteredReportsCounter = this.countedReports;
        }
      },
      error => {
        console.error(error);
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, 'Błąd w trakcie pobierania listy raportów');
      }
    )
  }

  modifySelectedElementList(elementList: Array<string>, id: string, showResults?: boolean) {
    if (showResults === undefined)
      showResults = false;

    let position = elementList.indexOf(id);
    if (position === -1)
      elementList.push(id);
    else
      elementList.splice(position, 1);

    this.numberOfFilterCriteria = this.fileFormatsForFilterSelected.length
      + this.thematicsAreaForFilterSelected.length
      + this.thematicsClientGroupsForFilterSelected.length
      + this.thematicsFrequenciesForFilterSelected.length
      + this.thematicsInstitutionForFilterSelected.length
      + this.thematicsInstitutionForFilterSelected.length
      + this.thematicsProductsForFilterSelected.length
      + this.contentTypeForFilterSelected.length
      + this.hasRightsForFilterSelected.length;

    if (this.dateFromFilter) this.numberOfFilterCriteria++;
    if (this.dateToFilter) this.numberOfFilterCriteria++

    if (showResults)
      this.setPageWithProperData(this.currentPage);
    else
      this.prefilterDataForFilter();
  }

  /**
   * Rozwija i zwija widok raportu na liście raoportów prezentowanych użytkownikowi.
   * @param reportId
   */
  showHideMoreOnReport(reportId: number) {
    let position = this.reportShowMoreList.indexOf(reportId);
    if (position === -1) {
      this.reportShowMoreList.push(reportId);
      this.commonService.registerClickOnElement('rollDown', 'reportsList', 'report', reportId).subscribe(
        success => {
          if (success.status != 1)
            console.log(success.message);
        },
        error => {
          console.log(error);
        }
      );
    } else {
      this.reportShowMoreList.splice(position, 1);
      this.commonService.registerClickOnElement('rollUp', 'reportsList', 'report', reportId).subscribe(
        success => {
          if (success.status != 1)
            console.log(success.message);
        },
        error => {
          console.log(error);
        }
      );
    }
  }

  modifySelectedObjectList(objectList: Array<Dictionary>, object: Dictionary, showResults?: boolean) {
    if (showResults === undefined)
      showResults = false;

    let position = objectList.indexOf(object);
    if (position === -1)
      objectList.push(object)
    else
      objectList.splice(position, 1);

    this.numberOfFilterCriteria = this.fileFormatsForFilterSelected.length
      + this.thematicsAreaForFilterSelected.length
      + this.thematicsClientGroupsForFilterSelected.length
      + this.thematicsFrequenciesForFilterSelected.length
      + this.thematicsInstitutionForFilterSelected.length
      + this.thematicsInstitutionForFilterSelected.length
      + this.contentTypeForFilterSelected.length
      + this.thematicsProductsForFilterSelected.length
      + this.hasRightsForFilterSelected.length;

    if (this.dateFromFilter) this.numberOfFilterCriteria++;
    if (this.dateToFilter) this.numberOfFilterCriteria++;

    // this.getReports(showResults);
    if (showResults)
      this.setPageWithProperData(this.currentPage);
    else
      this.prefilterDataForFilter();
  }

  removeDateFromFromFilter(showResults) {
    this.dateFromFilter = null;
    this.dateFrom = null;
    this.numberOfFilterCriteria--;
    if (showResults)
      this.setPageWithProperData(this.currentPage);
    else
      this.prefilterDataForFilter();
  }

  removeDateToFromFilter(showResults) {
    this.dateToFilter = null;
    this.dateTo = null;
    this.numberOfFilterCriteria--;
    // this.getReports(showResults);
    if (showResults)
      this.setPageWithProperData(this.currentPage);
    else
      this.prefilterDataForFilter();
  }

  showFilterPopupClick(show: boolean) {
    this.showFilterPopup = show;
  }

  private clearFilters() {
    this.dateFromFilter = null;
    this.dateToFilter = null;
    this.fileFormatsForFilterSelected = [];
    this.thematicsAreaForFilterSelected = [];
    this.thematicsClientGroupsForFilterSelected = [];
    this.thematicsFrequenciesForFilterSelected = [];
    this.thematicsInstitutionForFilterSelected = [];
    this.thematicsProductsForFilterSelected = [];
    this.contentTypeForFilterSelected = [];
    this.hasRightsForFilterSelected = [];

    this.numberOfFilterCriteria = 0;
  }

  clearFiltersClick() {
    this.clearFilters();
    this.commonService.prefilterUserReports(this.buildFilterParams()).subscribe(
      result => {
        if (result.status != 1) {
          console.error(result);
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, 'Błąd w trakcie pobierania listy raportów');
        } else {
          this.countedReports = result.record;
          this.filteredReportsCounter = this.countedReports;
          this.setPageWithProperData(this.currentPage);
        }
      },
      error => {
        console.error(error);
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, 'Błąd w trakcie pobierania listy raportów');
      }
    )
  }

  private filterReportClick() {
    this.countedReports = this.filteredReportsCounter;
    this.setPageWithProperData(this.currentPage);

    this.showFilterPopup = false;
  }

  private setPageWithProperData(page: number) {
    this.currentPage = page;

    let filterParams = this.buildFilterParams()
    if (this.newReports)
      this.setFilterParamsForNewReports(filterParams);

    this.commonService.prefilterUserReports(filterParams).subscribe(
      result => {
        if (result.status != 1) {
          console.error(result);
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, 'Błąd w trakcie pobierania listy raportów');
        } else {
          this.countedReports = result.record;
          this.filteredReportsCounter = this.countedReports;

          this.pager = this.userReportsPagerService.getPager(this.countedReports, page, UserReportsComponent.pageSize);
          this.currentPage = this.pager.currentPage;
          this.getReports(true, this.currentPage, UserReportsComponent.pageSize, false);
        }
      },
      error => {
        console.error(error);
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, 'Błąd w trakcie pobierania listy raportów');
      }
    )
  }


  private downloadReportOnReportListClick(reportToOperateOn: Report) {
    this.reportToOperateOn = reportToOperateOn;
    this.showDownloadReport = true;
  }

  private downloadDemoOnReportListClick(reportToOperateOn: Report) {
    this.reportToOperateOn = reportToOperateOn;
    this.showDownloadDemo = true;
  }

  private closeDownloadDemoPopup() {
    this.reportToOperateOn = undefined;
    this.showDownloadDemo = false;
  }

  private showContactFormPopup() {
    this.showContactForm = true;
    let contactFormMessage = "Dzień dobry,\n\n".concat("poproszę o ofertę dotyczącą dostępu do raportu \"",
      this.reportToOperateOn.title, "\"\n\n", "Pozdrawiam\n\n", this.loggedUser.firstName, ' ', this.loggedUser.lastName);

    this.contactForm.controls['message'].setValue(contactFormMessage);
    this.commonService.registerClickOnElement('clickOnAskForOffer', 'reportsList', 'report', this.reportToOperateOn.id).subscribe(
      success => {
        if (success.status != 1)
          console.log(success.message);
      },
      error => {
        console.log(error);
      }
    );
  }

  private closeContactFormPopup() {
    this.showContactForm = false;
    this.contactFormMessage = '';
    this.contactForm.controls['agreement'].setValue(false);
    this.contactForm.controls['sendCopy'].setValue(false);
  }

  private downloadReportClick(report: Report) {
    this.commonService.downloadReportFile(report.id).subscribe(
      data => {
        saveAs(data, report.fileName);
      },
      err => {
        console.log(err);
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Wystąpił błąd! Nie można pobrać wskazanego raportu")
      }
    )
  }

  private downloadDemoClick() {
    this.commonService.downloadDemoFile(this.reportToOperateOn.id).subscribe(
      data => {
        saveAs(data, this.reportToOperateOn.demoFileName);
      },
      err => {
        console.log(err);
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Wystąpił błąd! Nie można pobrać DEMO wskazanego raportu")
      }
    )
  }

  private addToFavouritesClick(report: Report) {
    this.commonService.addToFavourites(report.id, this.loggedUserId).subscribe(
      result => {
        this.updateUserReportsCount();
        report.isFavourite = true;
        this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION, "Raport ".concat(report.title, " został dodany do Zapisanych"));
      },
      error => {
        console.log(error);
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Wystąpił błąd! Raport ".concat(report.title, " nie został dodany do Zapisanych"))
      }
    )
  }

  showReportSharePopup(show: boolean, reportToOperateOn?: Report) {
    this.showReportShare = show;

    if (reportToOperateOn)
      this.reportToOperateOn = reportToOperateOn;

    if (!show)
      this.reportToOperateOn = undefined;
    else
      this.shareReportForm.controls['email'].setValue('');
  }

  shareReportClick() {
    let email = this.shareReportForm.controls['email'].value;
    let message = this.shareReportForm.controls['message'].value;
    if (message === this.shareReportMessage)
      message = "";
    this.commonService.shareReport(this.reportToOperateOn.id, this.loggedUser.id, email, message).subscribe(
      result => {
        if (result.status == 1)
          this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION, "Wysłano link do raportu");
        else
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Wystąpił błąd: Link nie został wysłany");

        this.showReportShare = false;
        this.reportToOperateOn = undefined;
        this.shareReportForm.controls['email'].reset('');
        let userName = this.loggedUser.firstName + ' ' + this.loggedUser.lastName;
        this.shareReportForm.controls['message'].reset(this.shareReportMessage);
      });
  }

  sendAccesRequestToReportClick() {
    let message = this.contactForm.controls['message'].value;
    let sendCopy = this.contactForm.controls['sendCopy'].value;
    this.commonService.sendAccessRequestUrl(this.loggedUser.id, this.reportToOperateOn.id, message, sendCopy).subscribe(
      result => {
        if (result.status == 1)
          this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION,
            "Wysłano prośbę o dostęp do raportu");
        else
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
            "Wystąpił błąd! Nie wysłano maila z prośbą o dostęp")
      },
      error => {
        console.log(error);
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
          "Wystąpił błąd! Nie wysłano maila z prośbą o dostęp")
      }
    );
    this.closeContactFormPopup();
  }

  private removeFromFavourites(report: Report) {
    let reportsToRemove = [];
    reportsToRemove.push(report.id);
    this.userSavedReportsService.removeReportsFromSaved(this.loggedUser.id, reportsToRemove).subscribe(
      result => {
        if (result.status != 1)
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
            "Wystąpił błąd! Nie usunięto raportu z zapisanych");
        else {
          this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION,
            "Raport ".concat(report.title, "został usunięty z zapisanych"));
          report.isFavourite = false;
          this.updateUserReportsCount();
        }
      },
      error => {
        console.log(error);
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
          "Wystąpił błąd! Nie usunięto raportu z zapisanych");
      }
    );
  }
}
